export default class DtoVariousMatPump {
    constructor(obj) {
        this.id = obj.id // Long,
        this.pumpType = obj.pumpType // Option[Long],
        this.maxFlow = obj.maxFlow // Option[Double],
        this.operatingFlow = obj.operatingFlow // Option[Double],
    }
}